import { render } from "./SelectTheme.vue?vue&type=template&id=df8cf526"
import script from "./SelectTheme.vue?vue&type=script&lang=js"
export * from "./SelectTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__